import React, { Component } from 'react';
import { AppCollapsible } from '../AppCollapsible';
import { alignOptions } from '../../../config/constants';
import './image.css';
import { previewImage } from '../../../utils/common';
import { Api } from '../../../api/api-routes';
import { connect } from 'react-redux';
import { showErrorAlert } from '../../../redux/actions/alert';
import placeholderImage from './wp_placeholder.png';
import { editInputWithProps } from '../../../redux/actions/inputWithProps';
import { AppInputWrapper } from '../AppInputWrapper';

class Image extends Component {

    constructor(props) {
        super(props);

        this.placeholderImage = placeholderImage;
    }

    state = {
        aligned: this.props.initialValues.align || alignOptions[0].value,
        src: this.props.initialValues.url || '',
        file: null,
        width: this.props.initialValues.width || '',
        height: this.props.initialValues.height || ''
    };

    updateInputPropsInStore = () => {
        const inputProps = {
            type: this.props.initialValues.type,
            url: this.state.src,
            align: this.state.aligned,
            width: this.state.width,
            height: this.state.height
        };

        this.props.editInputWithProps(this.props.initialValues.id, inputProps);
    };

    componentDidMount() {
        setTimeout(_ => {
            this.updateInputPropsInStore();
        }, 500);
    }

    componentDidUpdate() {
        this.updateInputPropsInStore();
    }

    setAlignment = (e) => {
        this.setState({ aligned: e.target.value });
    };

    setWidth = (e) => {
        this.setState({width: e.target.value})
    }

    setHeight = (e) => {
        this.setState({height: e.target.value})
    }

    saveImage = () => {
        const formData = new FormData();
        formData.append('file', this.state.file);
        formData.append('type', 'imageType');

        Api.saveImage(formData)
            .then(res => {
                if (res.status === 'success') {
                    this.setState({ src: res.url, file: null });
                } else {
                    this.props.showErrorAlert(res.errorMessage);
                }
            })
            .catch(e => {
                this.props.showErrorAlert(e.message);
            })
    };

    selectImage = (event) => {
        previewImage({
            file: event.target.files[0],
            cb: (preview) => {
                this.setState({ src: preview, file: event.target.files[0] });
            }
        });
    }

    handleCancelBtn = (event) => {
        event.target.value = '';
        this.setState({ src: '', file: null });
    }

    render() {
        const { aligned, file, src, width, height } = this.state;

        return (
            <>
                <AppInputWrapper>
                    <img
                        style={{ alignSelf: aligned, width: width + 'px', height: height + 'px', maxWidth: '100%' }}
                        className="image-type-input"
                        src={src || this.placeholderImage}
                        alt=""
                    />
                </AppInputWrapper>

                {
                    !this.props.isResultInput &&
                    <>
                        <div className="image-type-tools">
                            {
                                file &&
                                <button
                                    className="upload-image-type-btn"
                                    onClick={this.saveImage}
                                >Upload image</button>
                            }

                            <label>
                                <input
                                    onChange={this.selectImage}
                                    onClick={this.handleCancelBtn}
                                    type="file"
                                    accept="image/png, image/jpeg"
                                />
                            </label>
                        </div>


                        <AppCollapsible>
                            <div className="settings-container">
                                <label>
                                    <select
                                        className="image-alignment-select"
                                        onChange={this.setAlignment}
                                        value={aligned}
                                    >
                                        {
                                            alignOptions.map((el, i) => (
                                                <option value={el.value} key={i}>{ el.label }</option>
                                            ))
                                        }
                                    </select>
                                    Image alignment
                                </label>
                                <label>
                                    <input value={this.state.width} onChange={this.setWidth} type="text" placeholder={"Enter width"}/>
                                </label>
                                <label>
                                    <input value={this.state.height} onChange={this.setHeight} type="text" placeholder={"Enter height"}/>
                                </label>
                            </div>
                        </AppCollapsible>
                    </>
                }
            </>
        );
    }
}

export default connect(
    () => ({}),
    {
        showErrorAlert,
        editInputWithProps
    }
)(Image);